/* Visuel du hero de l'espace pro.
   EP_ARCH_PHOTO = URL de l'image chargée dans Contenu > Fichiers.
   Photo large (ratio > 1.35) : le balayage est découpé sur l'écran de l'ordinateur.
   Photo carrée : cadre classique. Aucune image : rendu vectoriel de secours. */
var EP_ARCH_PHOTO = "https://cdn.shopify.com/s/files/1/0436/8406/9538/files/arcade-scan.png?v=1790194093";

function buildArch(){
  var CX=210, CY=262, AX=150, AY=178, TM=1.45;
  function P(t){var h=t*TM;return [CX+AX*Math.sin(h), CY-AY*(1-Math.cos(h))];}
  function D(t){var h=t*TM;return [AX*Math.cos(h)*TM, -AY*Math.sin(h)*TM];}
  var N=1200, TS=[], CU=[0], i, a, b;
  for(i=0;i<=N;i++) TS.push(-1+2*i/N);
  for(i=1;i<=N;i++){a=P(TS[i-1]);b=P(TS[i]);CU.push(CU[i-1]+Math.hypot(b[0]-a[0],b[1]-a[1]));}
  var TOT=CU[N];
  function tAt(s){s=Math.max(0,Math.min(TOT,s));var lo=0,hi=N,m;while(lo<hi){m=(lo+hi)>>1;if(CU[m]<s)lo=m+1;else hi=m;}return TS[lo];}
  function nrm(t,off){
    var p=P(t),d=D(t),nx=d[1],ny=-d[0],L=Math.hypot(nx,ny);nx/=L;ny/=L;
    if((CX-p[0])*nx+((CY-AY*0.6)-p[1])*ny>0){nx=-nx;ny=-ny;}
    return [p[0]+nx*off, p[1]+ny*off];
  }
  function band(off,span){
    var s="",k,q;
    for(k=0;k<=90;k++){q=nrm((-1+2*k/90)*span,off);s+=(k?" L ":"M ")+q[0].toFixed(1)+" "+q[1].toFixed(1);}
    return s;
  }
  var H=[["m",10.6,11.2,2.7,4],["m",11.2,11.6,2.7,4],["p",7.2,9.2,2.3,2],["p",7.4,9.4,2.3,2],
         ["c",8.0,8.8,2.1,1],["l",6.6,6.6,2.6,0],["i",8.6,7.2,2.9,0]];
  var T=H.concat(H.slice().reverse()), GAP=0.55, raw=0;
  for(i=0;i<T.length;i++) raw+=T[i][1];
  raw+=GAP*(T.length-1);
  var SC=TOT*0.985/raw;
  function se(w,h,sq,n){
    var p=[],k,ang,c,s;
    for(k=0;k<n;k++){ang=2*Math.PI*k/n;c=Math.cos(ang);s=Math.sin(ang);
      p.push([(w/2)*Math.pow(Math.abs(c),2/sq)*(c>=0?1:-1),(h/2)*Math.pow(Math.abs(s),2/sq)*(s>=0?1:-1)]);}
    return p;
  }
  function sm(p){
    var n=p.length,d="M "+p[0][0].toFixed(1)+" "+p[0][1].toFixed(1),k,p0,p1,p2,p3,c1,c2;
    for(k=0;k<n;k++){
      p0=p[(k-1+n)%n];p1=p[k];p2=p[(k+1)%n];p3=p[(k+2)%n];
      c1=[p1[0]+(p2[0]-p0[0])/6,p1[1]+(p2[1]-p0[1])/6];
      c2=[p2[0]-(p3[0]-p1[0])/6,p2[1]-(p3[1]-p1[1])/6];
      d+=" C "+c1[0].toFixed(1)+" "+c1[1].toFixed(1)+" "+c2[0].toFixed(1)+" "+c2[1].toFixed(1)+" "+p2[0].toFixed(1)+" "+p2[1].toFixed(1);
    }
    return d+" Z";
  }
  var teeth=[], s=(TOT-raw*SC)/2;
  for(i=0;i<T.length;i++){
    var w=T[i][1]*SC, dp=T[i][2]*SC;
    s+=w/2;
    var t=tAt(s), p=P(t), d=D(t);
    teeth.push({w:w,d:dp,sq:T[i][3],c:T[i][4],x:p[0],y:p[1],a:Math.atan2(d[1],d[0])*180/Math.PI+90});
    s+=w/2+GAP*SC;
  }
  var o=['<defs>'];
  var en=[["#FFFFFF","#D5DCE3"],["#FDFEFF","#D0D8E0"],["#FFFFFF","#D9E0E6"]];
  for(i=0;i<3;i++) o.push('<linearGradient id="ar-en'+i+'" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="'+en[i][0]+'"/><stop offset=".55" stop-color="'+en[i][1]+'"/><stop offset="1" stop-color="#B7C2CC"/></linearGradient>');
  o.push('<radialGradient id="ar-oc" cx="50%" cy="45%" r="60%"><stop offset="0" stop-color="#93A0AE" stop-opacity=".5"/><stop offset="1" stop-color="#93A0AE" stop-opacity="0"/></radialGradient>');
  o.push('<radialGradient id="ar-cu" cx="50%" cy="40%" r="60%"><stop offset="0" stop-color="#FFFFFF" stop-opacity=".9"/><stop offset="1" stop-color="#FFFFFF" stop-opacity="0"/></radialGradient>');
  o.push('<linearGradient id="ar-gum" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#93585F"/><stop offset=".55" stop-color="#6E3F46"/><stop offset="1" stop-color="#3F252A"/></linearGradient>');
  o.push('<filter id="ar-b1" x="-40%" y="-40%" width="180%" height="180%"><feGaussianBlur stdDeviation="11"/></filter>');
  o.push('<filter id="ar-b2" x="-40%" y="-40%" width="180%" height="180%"><feGaussianBlur stdDeviation="4"/></filter>');
  o.push('<filter id="ar-b3" x="-40%" y="-40%" width="180%" height="180%"><feGaussianBlur stdDeviation="1.6"/></filter>');
  o.push('</defs>');
  o.push('<path d="'+band(0,1.02)+'" stroke="#1B6BFF" stroke-width="46" fill="none" opacity=".13" filter="url(#ar-b1)"/>');
  o.push('<path d="'+band(0,1.03)+'" stroke="#472A2F" stroke-width="74" fill="none" opacity=".45" filter="url(#ar-b2)"/>');
  o.push('<path d="'+band(0,1.03)+'" stroke="url(#ar-gum)" stroke-width="53" fill="none" opacity=".96" filter="url(#ar-b3)"/>');
  o.push('<path d="'+band(30,1.03)+'" stroke="#79ADFF" stroke-width="1.6" fill="none" opacity=".38" stroke-linecap="round"/>');
  o.push('<path d="'+band(31,1.03)+'" stroke="#79ADFF" stroke-width="7" fill="none" opacity=".14" filter="url(#ar-b3)" stroke-linecap="round"/>');
  o.push('<g opacity=".35" filter="url(#ar-b3)" transform="translate(0 3)">');
  for(i=0;i<teeth.length;i++){var q=teeth[i];
    o.push('<g transform="translate('+q.x.toFixed(1)+' '+q.y.toFixed(1)+') rotate('+q.a.toFixed(1)+')"><path d="'+sm(se(q.w*1.02,q.d*1.02,q.sq,22))+'" fill="#1A1014"/></g>');}
  o.push('</g>');
  for(i=0;i<teeth.length;i++){
    var q=teeth[i], pts=se(q.w,q.d,q.sq,30), g=[];
    g.push('<g transform="translate('+q.x.toFixed(1)+' '+q.y.toFixed(1)+') rotate('+q.a.toFixed(1)+')">');
    g.push('<path d="'+sm(pts)+'" fill="url(#ar-en'+(i%3)+')" stroke="rgba(120,132,146,.55)" stroke-width=".55"/>');
    g.push('<path d="'+sm(pts.map(function(z){return [z[0]*.72,z[1]*.72];}))+'" fill="url(#ar-oc)" opacity=".55"/>');
    if(q.c===4){
      [[-.3,-.3],[.3,-.3],[-.3,.3],[.3,.3]].forEach(function(z){
        g.push('<ellipse cx="'+(z[0]*q.w).toFixed(1)+'" cy="'+(z[1]*q.d).toFixed(1)+'" rx="'+(q.w*.22).toFixed(1)+'" ry="'+(q.d*.22).toFixed(1)+'" fill="url(#ar-cu)" opacity=".85"/>');});
      g.push('<path d="M '+(-q.w*.3).toFixed(1)+' '+(-q.d*.26).toFixed(1)+' Q 0 0 '+(q.w*.3).toFixed(1)+' '+(-q.d*.26).toFixed(1)+' M 0 0 L 0 '+(q.d*.3).toFixed(1)+'" stroke="rgba(112,124,138,.22)" stroke-width=".6" fill="none" stroke-linecap="round"/>');
    } else if(q.c===2){
      [-.26,.26].forEach(function(z){
        g.push('<ellipse cx="0" cy="'+(z*q.d).toFixed(1)+'" rx="'+(q.w*.3).toFixed(1)+'" ry="'+(q.d*.2).toFixed(1)+'" fill="url(#ar-cu)" opacity=".85"/>');});
      g.push('<path d="M '+(-q.w*.3).toFixed(1)+' 0 L '+(q.w*.3).toFixed(1)+' 0" stroke="rgba(112,124,138,.26)" stroke-width=".6" stroke-linecap="round"/>');
    } else if(q.c===1){
      g.push('<path d="M '+(-q.w*.32).toFixed(1)+' '+(q.d*.1).toFixed(1)+' Q 0 '+(-q.d*.34).toFixed(1)+' '+(q.w*.32).toFixed(1)+' '+(q.d*.1).toFixed(1)+'" fill="none" stroke="rgba(112,124,138,.26)" stroke-width=".6" stroke-linecap="round"/>');
      g.push('<ellipse cx="0" cy="'+(-q.d*.16).toFixed(1)+'" rx="'+(q.w*.26).toFixed(1)+'" ry="'+(q.d*.24).toFixed(1)+'" fill="url(#ar-cu)" opacity=".9"/>');
    } else {
      g.push('<rect x="'+(-q.w*.36).toFixed(1)+'" y="'+(-q.d*.44).toFixed(1)+'" width="'+(q.w*.72).toFixed(1)+'" height="'+(q.d*.34).toFixed(1)+'" rx="'+(q.d*.12).toFixed(1)+'" fill="url(#ar-cu)" opacity=".75"/>');
    }
    g.push('<ellipse cx="0" cy="'+(q.d*.34).toFixed(1)+'" rx="'+(q.w*.4).toFixed(1)+'" ry="'+(q.d*.16).toFixed(1)+'" fill="#6E7C8B" opacity=".13"/>');
    g.push('<ellipse cx="'+(-q.w*.1).toFixed(1)+'" cy="'+(-q.d*.28).toFixed(1)+'" rx="'+(q.w*.16).toFixed(1)+'" ry="'+(q.d*.075).toFixed(1)+'" fill="#fff" opacity=".3"/>');
    g.push('</g>');
    o.push(g.join(''));
  }
  return o.join('');
}

(function(){
  var scan=document.getElementById("EpScan"),
      host=document.getElementById("EpArch"),
      img=document.getElementById("EpArchImg");
  if(!scan) return;

  function heroOf(el){
    while(el && el.classList && !el.classList.contains("ep-hero")) el=el.parentNode;
    return (el && el.classList) ? el : null;
  }
  function vector(){
    if(img) img.style.display="none";
    if(host){ host.style.display=""; try{ host.innerHTML=buildArch(); }catch(e){} }
    scan.classList.add("is-in");
  }
  function photo(){
    if(host) host.style.display="none";
    var w=img.naturalWidth||0, h=img.naturalHeight||0;
    if(w && h && (w/h) > 1.35){
      scan.classList.add("is-wide");
      var hero=heroOf(scan);
      if(hero) hero.classList.add("has-wide");
      if(!scan.querySelector(".scr")){
        var s=document.createElement("div");
        s.className="scr";
        s.innerHTML="<i></i>";
        scan.appendChild(s);
      }
    }
    scan.classList.add("is-in");
  }
  function start(){
    if(!img) return vector();
    img.addEventListener("load",photo);
    img.addEventListener("error",vector);
    if(EP_ARCH_PHOTO){ img.src=EP_ARCH_PHOTO; return; }
    if(img.complete) return img.naturalWidth>0 ? photo() : vector();
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",start); else start();
})();